import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceArea, ResponsiveContainer } from "recharts";

const GRADE_COLORS = { 0: "#10b981", 1: "#f59e0b", 2: "#f97316", 3: "#ef4444", 4: "#7f1d1d" };

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit" }) : "");

export const LabMarkerChart = ({ marker }) => {
  const data = marker.points.map((p) => ({
    date: fmtDate(p.sampleDate),
    value: p.value,
    grade: p.ctcaeGrade,
    pending: p.source === "OCR" && !p.validated && !p.rejected,
    rejected: p.rejected,
    source: p.source,
  })).filter((p) => !p.rejected);
  const values = data.map((d) => d.value);
  const ref = marker.reference || {};
  const lo = Math.min(...values, ref.min ?? Infinity);
  const hi = Math.max(...values, ref.max ?? -Infinity);
  const pad = (hi - lo) * 0.15 || 1;

  return (
    <div className="dash-card" data-testid={`lab-chart-${marker.key}`}>
      <div className="flex items-baseline justify-between mb-2">
        <h4 className="font-semibold text-slate-800 text-sm">{marker.label} <span className="text-slate-400 font-normal">({marker.unit})</span></h4>
        {marker.last && (
          <span className="text-sm font-bold" style={{ color: GRADE_COLORS[marker.last.ctcaeGrade] || "#0f172a" }} data-testid={`lab-last-${marker.key}`}>
            {marker.last.value} {marker.unit}{marker.last.ctcaeGrade > 0 ? ` · G${marker.last.ctcaeGrade}` : ""}
          </span>
        )}
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data} margin={{ top: 8, right: 12, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} />
          <YAxis domain={[Math.floor(lo - pad), Math.ceil(hi + pad)]} tick={{ fontSize: 11 }} />
          {ref.min != null && <ReferenceArea y1={ref.min} y2={ref.max ?? hi + pad} fill="#10b981" fillOpacity={0.08} />}
          <Tooltip formatter={(v, _n, item) => [`${v} ${marker.unit}${item.payload.grade ? ` (grade ${item.payload.grade})` : ""}${item.payload.pending ? " — à valider" : ""}`, marker.label]} />
          <Line type="monotone" dataKey="value" stroke="#0f766e" strokeWidth={2}
            dot={(props) => {
              const { cx, cy, payload, index } = props;
              return <circle key={index} cx={cx} cy={cy} r={4} fill={payload.pending ? "#fff" : GRADE_COLORS[payload.grade] || "#0f766e"} stroke={GRADE_COLORS[payload.grade] || "#0f766e"} strokeWidth={2} strokeDasharray={payload.pending ? "2 2" : undefined} />;
            }} />
        </LineChart>
      </ResponsiveContainer>
      <p className="text-[11px] text-slate-400 mt-1">Bande verte : normes adultes · point creux : OCR à valider · couleur : grade CTCAE</p>
    </div>
  );
};

export default LabMarkerChart;
